import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Spinner, Link } from "components/common";
import NodeName from "views/components/messagelist/NodeName";
import usePluginEntities from "hooks/usePluginEntities";
import Routes from "routing/Routes";
const EPHEMERAL_COLLECTOR_INGEST_INPUT_ID = "000000000000000000000001";
const _inputName = (inputs, inputId, t) => {
  if (inputId === EPHEMERAL_COLLECTOR_INGEST_INPUT_ID) {
    return /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.COLLECTORS.OVERVIEW }, t("message.collector_ingest"));
  }
  const input = inputs.get(inputId);
  return input ? /* @__PURE__ */ React.createElement("span", { style: { wordBreak: "break-word" } }, input.title) : t("message.deleted_input");
};
const FormatReceivedBy = ({
  isLocalNode,
  inputs,
  sourceInputId,
  sourceNodeId
}) => {
  var _a;
  const { t } = useTranslation("common");
  const forwarderPlugin = usePluginEntities("forwarder");
  const ForwarderReceivedBy = (_a = forwarderPlugin == null ? void 0 : forwarderPlugin[0]) == null ? void 0 : _a.ForwarderReceivedBy;
  if (!sourceNodeId) {
    return null;
  }
  if (isLocalNode === void 0) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (isLocalNode === false) {
    return /* @__PURE__ */ React.createElement(ForwarderReceivedBy, { inputId: sourceInputId, forwarderNodeId: sourceNodeId });
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dt", null, t("message.received_by")), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "message.received_by_value",
      components: {
        inputName: /* @__PURE__ */ React.createElement("em", null, _inputName(inputs, sourceInputId, t)),
        node: /* @__PURE__ */ React.createElement(NodeName, { nodeId: sourceNodeId })
      }
    }
  )));
};
export default FormatReceivedBy;
